<template>
  <b-modal
    :visible="value"
    size="md"
    centered
    :title="`${$t('Exportar AFPnet')} - ${monthName(period ? period.month : '')} ${period ? period.year : ''}`"
    @change="(val) => $emit('input', val)"
    hide-footer
  >
    <b-overlay :show="loading">
      <div class="mb-1 text-muted font-small-3">
        {{ $t("Seleccione la empresa para generar el archivo Excel en formato oficial de AFPnet.") }}
      </div>

      <b-form-group :label="$t('Empresa')" label-for="empresa-select-afpnet">
        <v-select
          id="empresa-select-afpnet"
          v-model="selectedEmpresaId"
          :options="empresas"
          :reduce="(e) => e.id"
          label="razon_social"
          :placeholder="$t('Seleccione una empresa')"
          :clearable="false"
        />
      </b-form-group>

      <div class="d-flex justify-content-end mt-2">
        <b-button variant="outline-secondary" class="mr-1" @click="$emit('input', false)">
          {{ $t("Cancelar") }}
        </b-button>
        <b-button
          variant="primary"
          :disabled="!selectedEmpresaId || downloading"
          @click="downloadAfpnet"
        >
          <feather-icon icon="DownloadIcon" class="mr-50" />
          {{ $t("Descargar AFPnet") }}
        </b-button>
      </div>
    </b-overlay>
  </b-modal>
</template>

<script>
import PayrollPeriodService from "@/views/rrhh/views/payroll/services/payroll-period.service";

export default {
  name: "ExportAfpnetModal",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    period: {
      type: Object,
      default: () => ({}),
    },
    months: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      loading: false,
      downloading: false,
      empresas: [],
      selectedEmpresaId: null,
    };
  },
  watch: {
    value(val) {
      if (val) {
        this.fetchEmpresas();
      }
    },
  },
  created() {
    if (this.value) {
      this.fetchEmpresas();
    }
  },
  methods: {
    monthName(month) {
      const found = this.months.find((m) => m.id === Number(month));
      return found ? found.label : month;
    },

    async fetchEmpresas() {
      try {
        this.loading = true;
        const { data } = await PayrollPeriodService.getEmpresas();
        this.empresas = data;
        if (this.empresas.length > 0 && !this.selectedEmpresaId) {
          this.selectedEmpresaId = this.empresas[0].id;
        }
      } catch (error) {
        this.showToastError(
          error.response?.data?.message || "Error al cargar empresas."
        );
      } finally {
        this.loading = false;
      }
    },

    async downloadAfpnet() {
      if (!this.selectedEmpresaId || !this.period?.id) return;
      try {
        this.downloading = true;
        this.addPreloader();
        const response = await PayrollPeriodService.exportAfpnet({
          period_id: this.period.id,
          empresa_id: this.selectedEmpresaId,
        });

        const empresa = this.empresas.find((e) => e.id === this.selectedEmpresaId);
        const empName = empresa
          ? empresa.razon_social.replace(/[^a-zA-Z0-9]/g, "_")
          : "empresa";
        const filename = `afpnet_${empName}_${this.period.year}_${this.period.month}.xlsx`;

        this.forceFileDownload(response.data, filename);
        this.showToastSuccess(this.$t("Archivo AFPnet descargado correctamente."));
        this.$emit("input", false);
      } catch (error) {
        let msg = "Error al descargar el archivo AFPnet.";
        if (error.response?.data) {
          if (error.response.data instanceof Blob) {
            try {
              const text = await error.response.data.text();
              const parsed = JSON.parse(text);
              msg = parsed.message || parsed;
            } catch (e) {
              try {
                msg = await error.response.data.text();
              } catch (e2) {}
            }
          } else {
            msg = error.response.data.message || error.response.data;
          }
        }
        this.showToastError(msg);
      } finally {
        this.downloading = false;
        this.removePreloader();
      }
    },
  },
};
</script>
